import { render, staticRenderFns } from "./StudentLocation.vue?vue&type=template&id=01588620&scoped=true"
import script from "./StudentLocation.vue?vue&type=script&lang=js"
export * from "./StudentLocation.vue?vue&type=script&lang=js"
import style0 from "./StudentLocation.vue?vue&type=style&index=0&id=01588620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01588620",
  null
  
)

export default component.exports